import admin from './admin.json';
import assignment from './assignment.json';
import group from './group.json';
import role from './role.json';
import scope from './scope.json';

const en = {
  title: 'Access Control',
  caption:
    'Manage roles, administrators, and scope-based access across your organization. Use assignments to define who gets access to what, and when. To learn more read the <0>Access Control documentation</0>.',
  name: 'Name',
  type: 'Type',
  actions: 'Actions',
  close: 'Close',
  cancel: 'Cancel',
  save: 'Save',
  addToGroup: 'Add to Group',
  selectGroup: 'Select group',
  selectedEntities: 'Selected Entities',
  admin,
  role,
  scope,
  group,
  assignment,
};

export default en;
